<template>
  <el-card class="box-card" :body-style="{ padding: '0px' }">
    <!-- 卡片头部 -->
    <div slot="header" class="clearfix">
      <span style="font-weight: 600">{{ config.game[currentPage]?.title || '暂无' }}博主</span>
    </div>

    <!-- 博主列表 - 纯v-for渲染，无任何JS DOM操作 -->
    <div class="modern-grid">
      <!-- 空数据提示 -->
      <div v-if="biliUp[currentPage].length === 0" class="empty-tip">
        暂无相关博主数据
      </div>

      <!-- 博主链接列表 -->
      <a
          v-else
          v-for="(upObj, idx) in biliUp[currentPage]"
          :key="idx"
          :href="upObj.url"
          target="_blank"
          class="up-link"
          :title="upObj.url"
      >
        <!-- B站logo -->
        <img
            src="https://img.lkval.com/static/assets/BILI_2.png"
            class="bili-logo"
            alt="B站"
        />
        <!-- 博主名称 -->
        <span class="up-name">{{ upObj.name }}</span>
      </a>
    </div>
  </el-card>
</template>

<script>
import axios from 'axios'
import {config} from "../common/gameConfig";

export default {
  name: "BiliUpList",
  data() {
    return {
      biliUp: {
        'val': [],
        'cs2': [],
        'df': []
      }, // 博主列表数组，仅用于数据存储
    }
  },
  mounted() {
    // 页面挂载后加载数据
    this.getBiliUpList()
  },
  computed: {
    // 游戏配置
    config() {
      return config
    },
    // 当前选中的游戏页面
    currentPage() {
      return this.$store.state.currentPage
    }
  },
  // watch: {
  //   // 监听当前页面变化，重新加载对应游戏的博主列表
  //   currentPage: {
  //     handler(newVal) {
  //       if (newVal) {
  //         this.getBiliUpList()
  //       }
  //     },
  //     immediate: false
  //   }
  // },
  methods: {
    // 获取博主列表数据
    async getBiliUpList() {
      try {
        const response = await axios({
          method: 'get',
          url: '/api/blogs/get_bili_up_list',
          params: {game: this.currentPage},
          timeout: 10000 // 10秒超时保护
        })

        if (response.data.code === 0) {
          this.biliUp = response.data.bili_up || []
        } else {
          this.$message.error(`加载失败：${response.data.msg || '服务器返回错误'}`)
        }
      } catch (error) {
        console.error('获取博主列表失败：', error)
        this.$message.error('网络异常，无法加载博主列表')
        this.biliUp = {
          'val': [],
          'cs2': [],
          'df': [],
        } // 清空数据，避免旧数据残留
      }
    }
  }
}
</script>

<style scoped>
/* 基础样式 */
.clearfix {
  width: 100%;
}

.box-card {
  width: 480px;
}

/* 网格容器样式 */
.modern-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  height: 200px;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: auto;
  padding: 10px;
  background-color: #f8fafc;
  border-radius: 8px;
}

/* 空数据提示 */
.empty-tip {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
}

/* 博主链接样式 */
.up-link {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  text-decoration: none;
  background-color: #ffffff;
  border: 1px solid #f8d7da;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
  color: #FB7299;
}

/* 鼠标悬浮效果 */
.up-link:hover {
  background-color: #fff0f5;
  color: #e63946;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

/* B站logo样式 */
.bili-logo {
  width: 16px;
  height: 16px;
  margin-right: 3px;
  vertical-align: middle;
}

/* 博主名称 */
.up-name {
  line-height: 1;
}

/* 自定义滚动条 */
.modern-grid::-webkit-scrollbar {
  width: 6px;
}

.modern-grid::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.modern-grid::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.modern-grid::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>